import script from "./PaymentMethodTelmex.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentMethodTelmex.vue?vue&type=script&setup=true&lang=js"

import "./PaymentMethodTelmex.vue?vue&type=style&index=0&id=664e387e&scoped=true&lang=css"

import exportComponent from "C:\\development\\ON\\montalvo.ti\\dish-frontend-web-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-664e387e"]])

export default __exports__